/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import { object, bool } from 'prop-types';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import useStyles from 'isomorphic-style-loader/useStyles';
// import scriptLoader from 'react-async-script-loader';
import { compose } from 'recompose';
import withScript from '../../../../lib/scriptLoader';
import landerCss from '../UniversalTemplate/Templates/Lander/Lander.module.css';

// import Features from '../../Components/Features/Features';
import Features from '../UniversalTemplate/Components/Features/Features';
import Banners from '../UniversalTemplate/Components/Banners/Banners';
import Tiles from '../UniversalTemplate/Components/Tiles/Tiles';
import SubCollections from '../UniversalTemplate/Components/Merchandising/SubCollection/SubCollection';
import UniversalGiftFinder from '../GraphqlHomePage/Partials/GraphqlFindAGiftFast/GraphqlFoodGiftFinder';
import LoadCardIsleLib from '../../vendors/CardIsle/LoadCardIsleLib';
import { cardIslePluginConfig } from '../../../../state/ducks/Checkout/ducks/Recipient/ducks/CardIsle/CardIsle-Helpers';
import { addCardIsleGiftCardToCart } from '../../../../state/ducks/Recipient/ducks/CardIsle/CardIsle-Actions';
import { trackPage } from '../../../helpers/tracking/common/commonTrackingHelpers';
import GraphqlSeoHeadTags from '../GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';
import GraphqlBreadcrumbs from '../GraphqlCommonComponents/GraphqlBreadcrumbs/GraphqlBreadcrumbs';
import { trackEvent } from '../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import withPageView from '../../../helpers/tracking/hocs/withPageView';
import { isCardIsleOrigin } from '../../vendors/CardIsle/cardIsleMessageUtils';

const { sdkURL } = cardIslePluginConfig;

const CardIsleTemplate = ({
    rows, page, scriptLoaded, isScriptLoadSucceed, data,
}) => {
    useStyles(landerCss);
    const dispatch = useDispatch();
    const history = useHistory();
    const SEO = data.seo || null;

    // showing breadcrumb universal-lander
    const hasBreadcrumb = SEO?.breadcrumb?.length > 0;
    const universalBreadCrumb =  (classRef) => (
        hasBreadcrumb && <div className={landerCss[classRef]}><GraphqlBreadcrumbs breadCrumbArray={SEO.breadcrumb} /></div>
    );

    const GCSKU = 'C10007';

    const cardIsleReceiveMessage = (event) => {
        // verify that message came from Card Isle
        if (!isCardIsleOrigin(event.origin)) {
            return;
        }

        if (typeof event.data.status !== 'undefined' && typeof document !== 'undefined') {
            if (event.data.status === 'success') {
                const giftCards = event.data.gift_cards || [];
                const components = giftCards.map((giftCard) => ({
                    brandCode: giftCard.brandCode,
                    componentType: 'GIFTCARD',
                    productCode: giftCard.sku, // for test:|| GCSKU,
                    quantity: 1,
                    attributes: [
                        {
                            attributeName: 'thumbnail',
                            attributeValue: giftCard.imageSrc,
                        },
                        {
                            attributeName: 'amount',
                            attributeValue: giftCard.amount,
                        },
                        {
                            attributeName: 'text',
                            attributeValue: giftCard.brand,
                        },
                    ],
                }));
                const payload = {
                    sku: event.data.greeting?.greetingSKU || GCSKU,
                    brandCode: event.data.greeting?.greetingBrandCode || '1012',
                    greetingMessage: event.data.card_text,
                    greetingCardKey: event.data.pickup_code,
                    greetingCardImage: event.data.card_image,
                    greetingCardName: event.data.card_name,
                    greetingCardType: 'CI',
                    greetingThumbNail: event.data.card_thumbnail,
                    components,
                };
                // setState({ card });
                dispatch(addCardIsleGiftCardToCart(payload, history));
            }
        }
    };

    useEffect(() => {
        dispatch(trackEvent({
            eventCategory: data?.tracking?.tracking_event_category || '',
            eventAction: data?.tracking?.tracking_event_action || '',
            eventLabel: data?.tracking?.tracking_event_label || '',
        }));
    }, []);

    useEffect(() => {
        if (window.addEventListener) {
            window.addEventListener('message', cardIsleReceiveMessage, false);
        } else if (window.attachEvent) {
            window.attachEvent('onmessage', cardIsleReceiveMessage);
        }
        return (() => {
            if (typeof window !== 'undefined') {
                if (window.addEventListener && window.initiate_card_isle_widget) {
                    window.removeEventListener('message', cardIsleReceiveMessage, false);
                } else if (window.detachEvent) {
                    window.detachEvent('onmessage', cardIsleReceiveMessage);
                }
            }
        });
    }, []);

    const classes = `
        ${landerCss.root}
        ${page.page_settings?.page_margin ? landerCss.topMargin : ''}
        `;
    if (scriptLoaded) {
        return (
            <>
                <div className={classes}>
                    <LoadCardIsleLib />
                    {universalBreadCrumb('desktop')}
                    <GraphqlSeoHeadTags seoData={SEO} />
                    {
                        (rows || []).map((row) => {
                            const rowType = Object.keys(row)?.[0];
                            if (rowType === 'banner') return <Banners data={row} />;
                            if (rowType === 'product_feature') return <Features data={row} />;
                            if (rowType === 'tiles') return <Tiles data={row} />;
                            if (rowType === 'merchandising') return <SubCollections data={row} />;
                            if (rowType === 'interactive') return <UniversalGiftFinder data={row?.interactive} isUniversalLander ulGiftFinderCss={landerCss.ulGiftFinderCss} />;
                            return <></>;
                        })
                    }
                    {universalBreadCrumb('mobile')}
                </div>
            </>
        );
    }
    return <></>;
};

CardIsleTemplate.propTypes = {
    rows: object.isRequired,
    page: object.isRequired,
    scriptLoaded: bool.isRequired,
    isScriptLoadSucceed: bool.isRequired,
    data: object.isRequired,
};

const enhance = compose(
    trackPage({
        type: 'card-isle-giftcards',
        name: 'Card Isle Greeting Cards',
        pageType: 'card-isle-giftcards',
        pageName: 'Card Isle Greeting Cards',
    }),
    withPageView({
        pageViewSuccessTest: () => true,
        updateEveryRender: true,
    }),
);

export default enhance(withScript(sdkURL, false, false)(CardIsleTemplate));
